import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import Login from '../pages/Login';
import Layout from '../components/Layout';
import AddClients from '../pages/AddClients';
import AddDefaultData from '../pages/AddDefaultData';
import AddTestMaster from '../pages/AddTestMaster';
import AddGroupMaster from '../pages/AddGroupMaster';
import AddAuthModules from '../pages/AddAuthModules';
import UpdateSubscription from '../pages/UpdateSubscription';
import DepartmentMaster from '../pages/DepartmentMaster';
import CreateOnPremPatch from '../pages/CreateOnPremPatch';
import SqlScriptGenerator from '../pages/SqlScriptGenerator';

const PrivateRoute = ({ children }) => {
  // Allow access if user has done initial login (isAuthenticated)
  // The dashboard will handle showing modal for API authentication
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function Proutes() {
  return (
    <Routes>
        <Route path="/login" element={<Login />} />
        <Route
        path="/"
        element={
            <PrivateRoute>
            <Layout />
            </PrivateRoute>
        }
        >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="add-clients" element={<AddClients />} />
        <Route path="add-test-master" element={<AddTestMaster />} />
        <Route path="add-group-master" element={<AddGroupMaster />} />
        <Route path="department-master" element={<DepartmentMaster />} />
        <Route path="add-auth-modules" element={<AddAuthModules />} />
        <Route path="add-default-data" element={<AddDefaultData />} />
        <Route path="update-subscription" element={<UpdateSubscription />} />
        <Route path="create-on-prem-patch" element={<CreateOnPremPatch />} />
        <Route path="sql-script-generator" element={<SqlScriptGenerator />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>

  );
}

export default Proutes;